import React from 'react';
import PageTitle from '../PageTitle';
import { Helmet } from 'react-helmet';

const Refund = () => {

  return (
    <>
      <Helmet>
        <title>I'm Your Huckleberry | Refund Policy</title>
      </Helmet>
      <PageTitle title="Refund Policy" />
      <div className="container py-5">
        <h1>Refund Policy for I'm Your Huckleberry LLC</h1>
        <p>
          <strong>Effective Date:</strong> January 1st 2025
        </p>

        <p>
          At I'm Your Huckleberry LLC, we strive to provide the highest quality cleaning services to
          our customers. If for any reason you are not completely satisfied with the service
          provided, please review the following refund policy.
        </p>

        <h2>1. Satisfaction Guarantee</h2>
        <p>
          We are committed to ensuring your satisfaction with our cleaning services. If you are not
          satisfied with the results of your cleaning, please contact us within 24 hours of the
          service completion, and we will make reasonable efforts to address your concerns. We will
          return to re-clean the affected areas at no additional cost.
        </p>

        <h2>2. Refund Eligibility</h2>
        <p>Refunds will only be considered under the following conditions:</p>
        <ul>
          <li>
            <strong>Failure to Perform Services:</strong> If we do not provide the agreed-upon
            services, or the service was not performed to the agreed standards, a full refund may be
            issued, or we will offer to re-clean the affected areas at no additional charge.
          </li>
          <li>
            <strong>Customer Complaints:</strong> If you are dissatisfied with our service and we
            are unable to resolve the issue to your satisfaction within 24 hours (by re-cleaning or
            offering a fair solution), we may issue a partial or full refund at our discretion.
          </li>
        </ul>

        <h2>3. Non-Refundable Situations</h2>
        <p>Refunds will not be issued under the following circumstances:</p>
        <ul>
          <li>
            <strong>Change of Mind:</strong> If you simply change your mind about the service after
            it has been completed.
          </li>
          <li>
            <strong>Pre-existing Conditions:</strong> If damages or issues existed prior to our
            cleaning service (e.g., stains that cannot be removed or areas that were not cleaned due
            to customer restrictions).
          </li>
          <li>
            <strong>Pets and Personal Property:</strong> If pets were not secured, or personal
            property was damaged due to customer negligence or failure to disclose potential issues
            (e.g., fragile items or security concerns), no refund will be issued.
          </li>
          <li>
            <strong>Cancellations:</strong> If the service is canceled within 1 week of the
            scheduled appointment, a cancellation fee may apply, and a refund will not be issued for
            canceled services.
          </li>
        </ul>

        <h2>4. How to Request a Refund</h2>
        <p>If you believe you are entitled to a refund, please follow these steps:</p>
        <ol>
          <li>Contact us within 24 hours of service completion via email or phone.</li>
          <li>Provide a detailed explanation of your concerns or dissatisfaction.</li>
          <li>
            Allow us the opportunity to resolve the issue by offering a re-cleaning or alternative
            solution.
          </li>
          <li>
            If the issue cannot be resolved, we will review the refund request and process it
            accordingly.
          </li>
        </ol>
        <p>
          Refunds will typically be processed within 7-10 business days following approval. The
          refund will be issued using the same payment method used for the original transaction,
          unless otherwise agreed upon.
        </p>

        <h2>5. Discretion of Refunds</h2>
        <p>
          Refund requests are reviewed on a case-by-case basis. I'm Your Huckleberry LLC reserves
          the right to deny refund requests that do not meet the criteria outlined above or if the
          request is found to be unreasonable.
        </p>

        <h2>6. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Refund Policy, or to request a refund,
          please contact us at:
        </p>
        <address>
          I'm Your Huckleberry LLC
          <br />
          Email:{' '}
          <a href="mailto:huckleberryhandyhomecleaning@gmail.com">
            huckleberryhandyhomecleaning@gmail.com
          </a>
          <br />
          Phone: <a href="tel:+17156518170">715-651-8170</a>
          <br />
          Mailing Address: 1900 Babcock Avenue, Cumberland, WI 54829
        </address>
      </div>
    </>
  );
};

export default Refund;
